import type { ConsultantAction } from '../../data/consultant'

export type ChatRole = 'assistant' | 'user'

export type ChatMessage = {
  id: string
  role: ChatRole
  text: string
  actions?: ConsultantAction[]
}

/** A reply the engine (or a future backend) wants the consultant to say. */
export type ConsultantReply = {
  text: string
  actions?: ConsultantAction[]
}

export type ConsultantFlow = 'idle' | 'discovery' | 'brief'

export type BriefAnswers = {
  name?: string
  email?: string
  company?: string
  industry?: string
  service?: string
  budget?: string
  timeline?: string
  goals?: string
  notes?: string
}

/**
 * Everything the consultant remembers for the visitor's session. Passed to and
 * returned from the engine so the same shape can be sent to a backend later.
 */
export type ConsultantSession = {
  flow: ConsultantFlow
  /** Service the conversation is currently about (serviceGuide id). */
  focus?: string
  stage?: string
  industry?: string
  scope?: string
  budget?: string
  discoveryStep: number
  briefStep: number
  brief: BriefAnswers
  /** Topic ids already answered, so we don't repeat ourselves verbatim. */
  answered: string[]
  /** Every service discussed so far — keeps follow-up questions in context. */
  mentioned?: string[]
  /** Number of visitor turns in this conversation. */
  turns?: number
  /** Follow-up question keys already asked, so we never ask twice. */
  askedFollowUps?: string[]
}

export type EngineResult = {
  replies: ConsultantReply[]
  session: ConsultantSession
  /** Set when the qualification brief has just been completed. */
  briefComplete?: boolean
}

export const createSession = (): ConsultantSession => ({
  flow: 'idle',
  discoveryStep: 0,
  briefStep: 0,
  brief: {},
  answered: [],
  mentioned: [],
  turns: 0,
  askedFollowUps: [],
})

export type { ConsultantAction }
